import { useState } from "react";
import { statusMeta, type FeedItem } from "@/mocks/news";

interface FeedCardProps {
  item: FeedItem;
  index: number;
}

export default function FeedCard({ item, index }: FeedCardProps) {
  const [expanded, setExpanded] = useState(index === 0);
  const meta = statusMeta[item.status];

  return (
    <article className="relative pl-8 sm:pl-12">
      <span
        className={`absolute left-[7px] top-6 flex h-4 w-4 items-center justify-center rounded-full ring-4 ring-background-50 sm:left-[11px] ${meta.dot}`}
        aria-hidden="true"
      ></span>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 md:p-5">
        <div className="flex flex-wrap items-center gap-2">
          <span className={`rounded-full border px-2.5 py-0.5 text-xs font-medium ${meta.chip}`}>{item.status}</span>
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">{item.category}</span>
          <span className="ml-auto text-xs text-foreground-500">
            {item.date} {item.time}
          </span>
        </div>

        <h3 className="mt-3 font-heading text-lg font-semibold leading-snug text-foreground-950">{item.title}</h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.summary}</p>

        <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-pulse-line text-primary-500"></i>
            热度 {item.heat.toLocaleString("zh-CN")}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-link-m"></i>
            {item.source}
          </span>
          <button
            type="button"
            onClick={() => setExpanded((v) => !v)}
            aria-expanded={expanded}
            className="ml-auto flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md px-2 py-1 font-medium text-primary-600 transition-colors hover:bg-primary-50"
          >
            {expanded ? "收起进展" : "查看进展"}
            <i className={expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
          </button>
        </div>

        {expanded && (
          <ol className="mt-4 space-y-2.5 rounded-md bg-background-100 p-4">
            {item.progress.map((step, stepIndex) => (
              <li key={step} className="flex items-start gap-3 text-sm text-foreground-700">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-background-50 text-[11px] font-medium text-foreground-600">
                  {stepIndex + 1}
                </span>
                {step}
              </li>
            ))}
          </ol>
        )}
      </div>
    </article>
  );
}